import MinimalTextBox from '@sophocles/components/FormFields/MinimalTextBox/MinimalTextBox';

export default MinimalTextBox;
